import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';

import { GatewayCommissioningStore, GATEWAY_COMMISSIONING_STEP } from '@store';

@Component({
  selector: 'app-gateway-commissioning',
  templateUrl: './gateway-commissioning.component.html',
  styleUrls: ['./gateway-commissioning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GatewayCommissioningComponent implements OnDestroy {
  readonly step = GATEWAY_COMMISSIONING_STEP;

  constructor(public gatewayCommissioningStore: GatewayCommissioningStore) {}

  ngOnDestroy(): void {
    this.gatewayCommissioningStore.clearState();
  }
}
